const onEnd =
  (handler) =>
  (e, ...args) => {
    if (e.key === 'End') {
      handler(e, ...args);
    }
  };

export default onEnd;
